import { Component, OnInit, Input} from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { IRoughcheck, IAssessment, ISection, IQuestion, IQFeedback} from '../roughcheck';
import { MessageService } from '../message.service';
import { RoughcheckService } from '../roughcheck.service';
import { LoggerService } from '../logger.service';

@Component({
  selector: 'app-question-feedback',
  templateUrl: './question-feedback.component.html',
})
export class QuestionFeedbackComponent implements OnInit {

  @Input() question: IQuestion = {
    section: 0,
    id: 0,
    xref: '00000000-0000-0000-0000-000000000000',
    title: '',
    description: '',
    risk_id: 0,
    risk_trigger: 0,
    reward_id: 0,
    reward_trigger: 0,
    progress: 0,
    notes: '',
  };

  feedback: IQFeedback = {
    id: 0,
    section_id: 0,
    question_id: 0,
    xref: '',
    notes: '',
  };
  qFeedbackNotesForm = this.fb.group({
    notes: [''],
  });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private service: RoughcheckService,
    private message: MessageService,
    private logger: LoggerService,
  ) { }

  ngOnInit(): void {
    const q = this.service.getQuestion();
    if (q) {
      this.question = q;
    } else {
      this.closePopup();
      return;
    }

    window.scroll(0, 0);

    this.service.getHttpQFeedback(this.question)
      .subscribe(
        (resp) => this.handleSuccess(resp),
        (error) => this.service.handleError(error)
      );
  }

  /**
   * Save notes and return to questions
   */
  onSubmit() {
    const data = this.qFeedbackNotesForm.controls.notes.value;
    this.feedback.notes = data;
    this.service.setHttpQFeedback(this.question, this.feedback)
      .subscribe(
        (resp) => this.handleSuccess(resp),
        (error) => this.service.handleError(error)
      );
  }

  /**
   * Return to questions without saving
   */
  onCancel() {
    this.router.navigate(['/a', this.service.getRRef(), this.service.getARef(), 'sections']);
  }

  /**
   * Delete the question then return to questions
   */
  onDelete() {
    // TODO
    const data = this.qFeedbackNotesForm.controls.notes.value;
    // this.feedback.notes = data;
    // this.service.setHttpQFeedback(this.feedback)
    //  .subscribe(
    //    (resp) => this.handleSuccess(resp),
    //    (error) => this.service.handleError(error)
    //  );
  }

  /**
   * Populate question feedback
   */
  private handleSuccess(resp: HttpResponse<any>) {
    this.feedback = {
      id: resp.body.id,
      section_id: resp.body.section_id,
      question_id: resp.body.question_id,
      xref: resp.body.xref,
      notes: resp.body.notes
    };
  }

  closePopup() {
    // Providing a `null` value to the named outlet
    // clears the contents of the named outlet
    this.router.navigate([{ outlets: { popup: null }}]);
  }

}
